/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum WidgetType {
  Inbound = 0,
  Document = 1,
  Archive = 2,
}

export enum WidgetColumnProp {
  Company = "company",
  Creditor = "creditor",
  InvoiceNo = "invoiceNo",
  DueDate = "dueDate",
  TotalAmount = "totalAmount",
  DocumentType = "documentType",
  Validation = "validation",
  Approvers = "approvers",
  Notes = "notes",
  Assignee = "assignee",
  Status = "status",
  DeclineReason = "declineReason",
  OnHoldReason = "onHoldReason",
  DeleteReason = "deleteReason",
  Deleted = "deleted",
  ExportError = "exportError",
  ExportDateTime = "exportDateTime",
  VoucherNumber = "voucherNumber",
  ArchiveCategory = "archiveCategory",
  ProjectNumber = "projectNumber",
  ShowDocument = "showDocument",
  ArchivedDate = "archivedDate",
  TimeSpent = "timeSpent",
  ExportStarted = "exportStarted",
}

/** @format int32 */
export enum VatScope {
  Domestic = 0,
  EUIntra = 1,
  OutsideEU = 2,
}

/** @format int32 */
export enum VatDirection {
  Sales = 0,
  Purchase = 1,
  Both = 2,
}

/** @format int32 */
export enum VatCategory {
  Standard = 0,
  Reduced = 1,
  Zero = 2,
  Exempt = 3,
  OutOfScope = 4,
  ReverseCharge = 5,
}

export enum ValidationConditionType {
  HasJournalEntries = "HasJournalEntries",
  InvoiceDateIsBeforeDueDate = "InvoiceDateIsBeforeDueDate",
  TotalAmountIsSumOfAccountingLines = "TotalAmountIsSumOfAccountingLines",
  RequiredItemFieldsAreFilled = "RequiredItemFieldsAreFilled",
  RequiredAccountingLinesAreFilled = "RequiredAccountingLinesAreFilled",
  NetPlusVatEqualsTotalAmount = "NetPlusVatEqualsTotalAmount",
  ValidatePaymentFields = "ValidatePaymentFields",
  DocumentHasNotBeenExported = "DocumentHasNotBeenExported",
  SelectedCreditorIsActive = "SelectedCreditorIsActive",
  SelectedAccountIsActive = "SelectedAccountIsActive",
  SelectedContraAccountIsActive = "SelectedContraAccountIsActive",
  DocumentIsDuplicate = "DocumentIsDuplicate",
  InvoiceDateWithinAllowedRange = "InvoiceDateWithinAllowedRange",
  DueDateWithinAllowedRange = "DueDateWithinAllowedRange",
  SelectedProjectIsActive = "SelectedProjectIsActive",
  SelectedCostTypeIsActive = "SelectedCostTypeIsActive",
  SelectedEmployeeIsActive = "SelectedEmployeeIsActive",
  ProjectRequiresCostType = "ProjectRequiresCostType",
  CostTypeRequiresProject = "CostTypeRequiresProject",
  CostTypeRequiresMatchingOngoingAccount = "CostTypeRequiresMatchingOngoingAccount",
  PaymentFieldsMatchCreditorDefaults = "PaymentFieldsMatchCreditorDefaults",
}

/** @format int32 */
export enum ValidationConditionOptionType {
  RequiredFields = 0,
  MaximumAgeDays = 1,
}

export enum ValidationAction {
  SendForReview = "SendForReview",
  Approve = "Approve",
  Export = "Export",
  NewDocument = "NewDocument",
}

/** @format int32 */
export enum UserWorkingState {
  IsWorking = 0,
  ItsNotWorking = 1,
  IsWorkingButMarkedForNotWorking = 2,
}

/** @format int32 */
export enum SourceType {
  Manuel = 0,
  XML = 1,
  OIO_UBL = 2,
  UTS = 3,
  OCR = 4,
  Peppol = 5,
  IslandskOIO = 6,
  Attachment = 7,
  SplitManual = 10,
  Pleo = 11,
  Travel = 12,
  Unknown = 13,
  SplitCloud = 14,
  Mileage = 15,
  OIOAttachment = 16,
  UserAttachment = 17,
  TravelAttachment = 18,
  MileageAttachment = 19,
  PleoAttachment = 20,
  Intercompany = 21,
  MergedAttachment = 22,
  Moved = 23,
  Archived = 24,
}

/** @format int32 */
export enum ReceivalType {
  Vans = 0,
  Email = 1,
}

/** @format int32 */
export enum ReasonTypes {
  OnHold = 1,
  Decline = 2,
  Archive = 3,
  Delete = 4,
  Exported = 5,
}

export enum PaymentScheme {
  NoneEmpty = "",
  None = "none",
  Fik = "FIK",
  BankAccount = "bankaccount",
  International = "international",
}

/** @format int32 */
export enum OcrDocumentType {
  Invoice = 0,
  GoodsInvoice = 1,
  CustomerOrder = 2,
  Requisition = 3,
  Other = 4,
}

/** @format int32 */
export enum NotificationContext {
  Item = 0,
  MultipleItems = 1,
  Announcement = 2,
  Comment = 3,
  Invitation = 4,
  User = 5,
}

/** @format int32 */
export enum NotificationActionType {
  None = 0,
  GoToItem = 1,
  GoToItems = 2,
  GoToUrl = 3,
}

/** @format int32 */
export enum MappingState {
  Unmapped = 0,
  Uncertain = 1,
  Mapped = 2,
}

/** @format int32 */
export enum LogLevel {
  None = 0,
  Basic = 1,
  Detailed = 2,
  Verbose = 3,
}

/** @format int32 */
export enum InvitationStep {
  Unsent = 0,
  Sent = 1,
  Details = 2,
  Password = 3,
  TwoFactor = 4,
  Completed = 99,
}

export enum IntegrationSystemType {
  ERP = "ERP",
  WMS = "WMS",
  Order = "Order",
  Salary = "Salary",
  Other = "Other",
}

/** @format int32 */
export enum InboundStatus {
  New = 0,
  Processing = 1,
  Processed = 2,
  Error = 3,
  Retry = 4,
  RetryOcr = 5,
  Finished = 99,
}

export enum ForwardPolicy {
  ReplaceMe = "replace",
  ApproverBeforeMe = "before",
  ApproverAfterMe = "after",
}

/** @format int32 */
export enum FlowTypes {
  StepFlow = 0,
  AcceptByMaxLimitAndNextApprover = 1,
  MultiFlow = 4,
  PaymentFlow = 5,
}

/** @format int32 */
export enum FlowStatus {
  NotInFlow = 0,
  InFlow = 1,
  FlowCancelled = 2,
  Declined = 3,
  Accepted = 4,
  Wait = 5,
  Deleted = 6,
  Exported = 7,
  Paid = 8,
  Archived = 9,
  ExportReady = 10,
  ExportFailed = 11,
  Minuba = 12,
  Microbizz = 13,
  PaymentApproved = 14,
  PaymentPending = 15,
  PaymentScheduled = 16,
  InPaymentFlow = 17,
  PaymentAwaitingCustomerPayment = 18,
  Moved = 19,
  PaymentAwaitingTransfer = 20,
  PaymentRejected = 21,
  PaymentCompleted = 22,
  Salary = 23,
  Ordrestyring = 24,
}

/** @format int32 */
export enum FlowState {
  NotSet = 0,
  NotStarted = 1,
  InFlow = 2,
  Ended = 3,
}

/** @format int32 */
export enum FlowReplyStatus {
  NotSet = 0,
  Accepted = 1,
  Declined = 2,
}

/** @format int32 */
export enum ExportStatusEnum {
  Pending = 0,
  Exported = 1,
  Error = 2,
  MissingVoucherNumber = 3,
  SuccessWithNoAttachment = 4,
}

/** @format int32 */
export enum DuplicateActionEnum {
  Delete = 0,
  MarkAsUnique = 1,
}

/** @format int32 */
export enum DocumentType {
  Invoice = 0,
  Travel = 1,
  Expense = 2,
  Split = 3,
  Mileage = 4,
  GoodsInvoice = 5,
  CustomerOrder = 6,
  Requisition = 7,
  CreditNote = 8,
  GoodsCreditNote = 9,
  None = -1,
}

/** @format int32 */
export enum DelegateType {
  User = 0,
  Flow = 1,
}

export enum ConditionType {
  Equals = "=",
  NotEquals = "!=",
  GreaterThan = ">",
  LessThan = "<",
  GreaterThanOrEqualTo = ">=",
  LessThanOrEqualTo = "<=",
  Contains = "contains",
  DoesNotContain = "does-not-contain",
  IsOneOf = "is-one-of",
  IsNotOneOf = "is-not-one-of",
  StartsWith = "starts-with",
  EndsWith = "ends-with",
  IsEmpty = "is-empty",
  IsNotEmpty = "is-not-empty",
}

export enum AutomationType {
  CreditorCheck = "creditor-check",
  SendToUser = "send-to-user",
  SendToFlow = "send-to-flow",
  CreateJournalEntries = "create-journal-entries",
  ApplyMostUsedJournalEntries = "apply-most-used-journal-entries",
  ApplyMostRecentJournalEntries = "apply-recently-used-journal-entries",
  ApplyMostUsedFlow = "apply-most-used-flow",
  ApplyMostRecentFlow = "apply-most-recent-flow",
}

export enum AutomationStatus {
  Deleted = "deleted",
  Disabled = "disabled",
  Active = "active",
  Paused = "paused",
}

export enum AutomationEventType {
  DocumentReceived = "document-received",
}

/** @format int32 */
export enum AutomationBlockType {
  Condition = 0,
  Action = 1,
  Loop = 2,
}

export enum AutomationBlockGroup {
  Document = "document",
  Flow = "flow",
  Dates = "dates",
  Amounts = "amounts",
  PaymentDetails = "payment-details",
  LoopChecks = "loop-checks",
  LoopActions = "loop-actions",
  JournalEntries = "journal-entries",
}

/** @format int32 */
export enum ActionType {
  Create = 1,
  Update = 2,
  Delete = 3,
  Read = 4,
  Execute = 5,
}

export interface Account {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountNumber: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountName: string;
  active?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   */
  vatCode?: string | null;
  vatGroup?: VatGroup;
  /**
   * @minLength 0
   * @maxLength 255
   */
  foreignName?: string | null;
}

export interface AccountPaginationResponseObject {
  data: Account[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface AccountingLine {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  ownerName?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountName?: string | null;
  /** @format double */
  amount?: number | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  period?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  postingText?: string | null;
  templateCreated?: boolean;
  /** @format int64 */
  sortId?: number;
  /**
   * @minLength 0
   * @maxLength 255
   */
  vatCode?: string | null;
  /** @format date-time */
  lineDate?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  contraAccountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  projectNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  costTypeNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  department?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  employeeNumber?: string | null;
  account?: Account;
  vatGroup?: VatGroup;
  contraAccount?: Account;
  project?: Project;
  employee?: Employee;
  costType?: CostType;
  [key: string]: any;
}

export interface AccountingLineRequest {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  ownerName?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountName?: string | null;
  /** @format double */
  amount?: number | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  period?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  postingText?: string | null;
  templateCreated?: boolean;
  /** @format int64 */
  sortId?: number;
  /**
   * @minLength 0
   * @maxLength 255
   */
  vatCode?: string | null;
  /** @format date-time */
  lineDate?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  contraAccountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  projectNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  costTypeNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  department?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  employeeNumber?: string | null;
  [key: string]: any;
}

export interface ActivityLog {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string;
  /** @format uuid */
  batchId?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  entity?: string | null;
  /** @format uuid */
  entityId?: string | null;
  /** @format uuid */
  relatedEntityId?: string | null;
  /**
   * @minLength 0
   * @maxLength 250
   */
  action: string;
  /** @format uuid */
  userId?: string | null;
  /** @format date-time */
  changeDate?: string;
  level: LogLevel;
  actionType: ActionType;
  /**
   * @minLength 0
   * @maxLength 450
   */
  batchMessage?: string | null;
  /**
   * @minLength 0
   * @maxLength 450
   */
  message?: string | null;
  /**
   * @minLength 0
   * @maxLength 15000
   */
  details?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  field?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  fieldType?: string | null;
  /**
   * @minLength 0
   * @maxLength 8000
   */
  oldValue?: string | null;
  /**
   * @minLength 0
   * @maxLength 8000
   */
  newValue?: string | null;
  /** @format date-time */
  created?: string;
}

export interface ActivityLogQuery {
  entity?: string | null;
  entities?: string[] | null;
  /** @format uuid */
  entityId?: string | null;
  batchMessages?: string[] | null;
}

export interface AddNoteRequest {
  /** @minLength 1 */
  comment: string;
}

export interface AddOioTemplateRequest {
  name?: string | null;
  templateData?: string | null;
  /** @format int32 */
  origin?: number;
  /** @format uuid */
  companyId?: string;
  /** @format uuid */
  organizationId?: string;
}

export interface AdministeredRole {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  normalizedName: string;
  /** @minLength 1 */
  translationKey: string;
  /** @minLength 1 */
  descriptionTranslationKey: string;
  /** @minLength 1 */
  icon: string;
  /** @format int32 */
  userCount: number;
  originalPermissions?: Permission[] | null;
  permissions?: Permission[] | null;
  widgets: Widget[];
  originalWidgets: Widget[];
}

export interface AdministeredUser {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  email: string;
  phoneNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  displayName: string | null;
  mustChangePassword?: boolean;
  isServiceUser?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   */
  employeeId?: string | null;
  isActive: boolean;
  /**
   * @minLength 0
   * @maxLength 10
   */
  language: string;
  profilePictureUrl?: string | null;
  companies: AdministeredUserCompany[];
  userInvitations?: UserInvitationBase[] | null;
  approvalLimits: ApprovalLimit[];
  workStatus?: WorkingStatus;
}

export interface AdministeredUserCompany {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  isAdmin?: boolean;
  isFavorite?: boolean;
  quickAccess?: boolean;
  company: Company;
  roleContext: RoleContext;
  delegate?: Delegate;
}

export interface AdministeredUserPaginationResponseObject {
  data: AdministeredUser[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface AdministeredWidget {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  normalizedName: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  description?: string | null;
  enabled: boolean;
  /**
   * @minLength 0
   * @maxLength 150
   */
  icon: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  color: string;
  itemAttributes?: string[] | null;
  originalItemAttributes?: string[] | null;
  itemButtons?: WidgetItemButton[] | null;
  originalItemButtons?: WidgetItemButton[] | null;
  originalPermissions?: Permission[] | null;
  permissions?: Permission[] | null;
}

export interface ApprovalLimit {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 25
   */
  currencyCode?: string | null;
  /** @format int32 */
  amount?: number;
  /** @format int32 */
  docType?: number;
  user?: UserReference;
}

export interface AuthUser {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  email: string | null;
  phoneNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  displayName: string | null;
  mustChangePassword?: boolean;
  isServiceUser?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   */
  employeeId?: string | null;
  isActive?: boolean;
  twoFactorEnabled?: boolean;
  /**
   * @minLength 0
   * @maxLength 10
   */
  language: string;
  profilePictureUrl?: string | null;
  twoFactorMandatory?: boolean;
  /** @format uuid */
  activeOrganisation: string;
  companies: AuthUserCompany[] | null;
  approvalLimits: ApprovalLimit[] | null;
  organisations: Organisation[] | null;
  activeInvitation?: UserInvitationStep;
  workStatus?: WorkingStatus;
}

export interface AuthUserCompany {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  companyName: string;
  /** @minLength 1 */
  companySerialNumber: string;
  /** @minLength 1 */
  companyDisplayName: string;
  /** @format uuid */
  companyOrganisationId: string;
  roleContextRoleNormalizedName?: string | null;
  delegate?: AuthUserDelegate;
  companyEnabledModules?: Module[] | null;
}

export interface AuthUserDelegate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  type?: DelegateType;
  /** @format uuid */
  userId?: string | null;
}

export interface Automation {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description: string | null;
  /** @format int32 */
  priority?: number;
  eventType: AutomationEventType;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  generatedDescription?: string | null;
  status: AutomationStatus;
  /** @format date-time */
  latestExecution?: string | null;
  /** @format int32 */
  executionCount?: number;
  blocks: AutomationBlock[];
  /** @format date-time */
  created?: string;
}

export interface AutomationBlock {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string;
  automationBlockType: AutomationBlockType;
  type: AutomationType;
  group: AutomationBlockGroup;
  condition?: ConditionType;
  options?: any;
  blocks?: AutomationBlock[] | null;
  /** @format date-time */
  created?: string;
}

export interface AutomationPaginationResponseObject {
  data: Automation[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface BatchRemindersResponse {
  /** @minLength 1 */
  tenantId: string;
  /** @format uuid */
  itemId: string;
}

export interface BulkExportInvoiceItemReference {
  /** @format uuid */
  itemId: string;
  /** @minLength 1 */
  tenantId: string;
}

export interface BulkExportInvoicesRequest {
  itemIds?: string[] | null;
  items?: BulkExportInvoiceItemReference[] | null;
}

export interface BulkExportInvoicesResponse {
  /** @format int32 */
  exportedItemsCount?: number;
  /** @format int32 */
  itemsWithMandatoryValidationsCount?: number;
  /** @format int32 */
  itemsWithOptionalValidationsCount?: number;
  itemsWithMandatoryValidations?: BulkExportInvoiceItemReference[] | null;
  itemsWithOptionalValidations?: BulkExportInvoiceItemReference[] | null;
}

export interface BulkImportTranslationsRequest {
  englishTranslations?: any;
  danishTranslations?: any;
  englishLanKey?: string | null;
  danishLanKey?: string | null;
}

export interface BulkImportTranslationsResponse {
  /** @format int32 */
  translationKeyCount?: number;
  /** @format int32 */
  totalProcessed?: number;
  /** @format int32 */
  createdCount?: number;
  /** @format int32 */
  updatedCount?: number;
  /** @format int32 */
  unchangedCount?: number;
  languageKeys?: string[] | null;
}

export interface BusinessAddress {
  address1?: string | null;
  address2?: string | null;
  zip_code?: string | null;
  city?: string | null;
  country?: string | null;
}

export interface ChangeEmailRequest {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  confirmEmail: string;
}

export interface ChangeReasonCategoryRequest {
  /** @format uuid */
  itemId?: string;
  /** @format uuid */
  reasonChoiceId?: string;
}

export interface Company {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format int32 */
  companyNumber?: number | null;
  /** @format date-time */
  createdDate?: string | null;
  /**
   * @minLength 0
   * @maxLength 250
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  serialNumber: string;
  isActive?: boolean;
  /**
   * @minLength 0
   * @maxLength 250
   */
  displayName?: string | null;
  /** @format date-time */
  deleteDate?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  ean?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  cvr?: string | null;
  /** @format uuid */
  organisationId?: string;
  integrations?: CompanyIntegration[] | null;
  enabledModules?: Module[] | null;
}

export interface CompanyIntegration {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  companyId: string;
  /** @format uuid */
  integrationTypeId: string;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  isActive: boolean;
  integrationType?: IntegrationType;
}

export interface CostType {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  costTypeNumber: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  vatCode?: string | null;
  active?: boolean;
  /**
   * @minLength 0
   * @maxLength 255
   */
  ongoingAccountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  closedAccountNumber?: string | null;
  /** @format double */
  markup?: number | null;
  ongoingAccount?: Account;
  closedAccount?: Account;
}

export interface CostTypePaginationResponseObject {
  data: CostType[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface CreateIntegrationResponse {
  /** @format uuid */
  integrationId: string;
  /** @minLength 1 */
  redirectUrl: string;
}

export interface CreateTranslationRequest {
  /** @minLength 1 */
  keyName: string;
  category?: string | null;
  subCategory?: string | null;
  /** @format int32 */
  maxLength?: number | null;
  texts: TranslationText[];
}

export interface CreateUserRequest {
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
  /**
   * @format password
   * @minLength 1
   */
  password: string;
  /**
   * @format string
   * @minLength 1
   */
  displayName: string;
  /** @format uuid */
  companyId: string;
  /** @minLength 1 */
  roleName: string;
}

export interface Creditor {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  creditorNumber: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  active?: boolean;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  cvr?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  address1?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  address2?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  zipCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  city?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phoneNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  contactName?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  contactEmail?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  contactPhone?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  webSite?: string | null;
  /**
   * @minLength 0
   * @maxLength 3
   */
  currencyCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  country?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  registrationNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  accountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  defaultPaymentCreditorId?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  defaultPaymentTermImportKey?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  defaultPaymentTypeImportKey?: string | null;
  defaultPaymentTerm?: PaymentTerm;
  defaultPaymentType?: PaymentType;
}

export interface CreditorPaginationResponseObject {
  data: Creditor[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface Customer {
  name?: string | null;
  id?: string | null;
  org_number?: string | null;
  external_id?: string | null;
  business_address?: BusinessAddress;
}

export interface DeclineRequest {
  /** @minLength 1 */
  reasonMessage: string;
}

export interface Delegate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  type?: DelegateType;
  /** @format uuid */
  userId?: string | null;
  user?: User;
}

export interface DeleteRequest {
  /** @minLength 1 */
  reasonMessage: string;
}

export interface Dimension {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  property: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  value?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  label?: string | null;
  active?: boolean;
  /**
   * @minLength 0
   * @maxLength 255
   */
  relation1?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  relation2?: string | null;
}

export interface DimensionPaginationResponseObject {
  data: Dimension[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface Document {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string | null;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  filename?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  orgFilename?: string | null;
  /** @format uuid */
  lineId?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  storagePath?: string | null;
  secureStoragePath?: string | null;
  mainDocument?: boolean;
  sourceType?: SourceType;
  /** @format int32 */
  origin?: number;
  /** @format int32 */
  fileSize?: number;
}

export interface DuplicateActionRequest {
  action?: DuplicateActionEnum;
}

export interface EcitWebhookRequest {
  customer?: Customer;
  files?: FileData[] | null;
}

export interface Employee {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  employeeNumber: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  externalUserId?: string | null;
  /** @format int32 */
  groupNumber?: number | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  email?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  address?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  city?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  zipCode?: string | null;
  active?: boolean;
  /** @format uuid */
  userId?: string | null;
  mappingState?: MappingState;
  user?: User;
}

export interface EmployeePaginationResponseObject {
  data: Employee[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface EmployeeRequest {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  employeeNumber: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  externalUserId?: string | null;
  /** @format int32 */
  groupNumber?: number | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  email?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  address?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  city?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  zipCode?: string | null;
  active?: boolean;
  /** @format uuid */
  userId?: string | null;
  mappingState?: MappingState;
}

export interface EnableMfaResponse {
  code?: string | null;
  sharedKey?: string | null;
  authenticatorUri?: string | null;
  errorMessage?: string | null;
  status?: string | null;
  recoveryCodes?: string[] | null;
}

export interface ErrorMessage {
  field?: string | null;
  message?: string | null;
  code?: string | null;
  description?: string | null;
  type?: string | null;
  severity?: string | null;
  source?: string | null;
  stackTrace?: string | null;
}

export interface ErrorResponseObject {
  message?: string | null;
  detail?: string | null;
  errors?: ErrorMessage[] | null;
}

export interface ExcelExportRequest {
  documentIds?: string[] | null;
}

export interface ExcelExportResponse {
  defaultFileName?: string | null;
  /** @format byte */
  fileData?: string | null;
}

export interface ExportStatus {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  itemId: string;
  /** @format uuid */
  companyIntegrationId: string;
  status: ExportStatusEnum;
  /**
   * @minLength 0
   * @maxLength 500
   */
  voucherNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 5000
   */
  errorMessage?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  errorCode?: string | null;
  companyIntegration?: CompanyIntegration;
  voucherUpdatedByUser?: User;
}

export interface ExtendedEntityField {
  /** @maxLength 100 */
  name: string | null;
  /** @maxLength 100 */
  type?: string | null;
  /** @maxLength 1000 */
  value?: any;
}

export interface FieldDefinition {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  widgetId?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  prop: string;
  label?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  type: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  section: string;
  /** @format int32 */
  minWidth?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  maxWidth?: number;
  /** @format int32 */
  sortOrder?: number;
  /** @format int32 */
  defaultSortOrder?: number;
  enabled?: boolean;
  visible?: boolean;
  readOnly?: boolean;
  required?: boolean;
  /**
   * @minLength 0
   * @maxLength 255
   */
  documentType?: string | null;
  /**
   * @minLength 0
   * @maxLength 555
   */
  defaultValue?: string | null;
  translations?: TranslateColumn[] | null;
}

export interface FileData {
  id?: string | null;
  externalDocumentId?: string | null;
  created_date?: string | null;
  created_time?: string | null;
  export_date?: string | null;
  export_time?: string | null;
  /** @format date-time */
  created_iso?: string;
  import?: ImportData;
  metadata?: Metadata;
  encoded?: string | null;
  filename?: string | null;
  import_file_name?: string | null;
  body?: string | null;
  documentId?: string | null;
}

export interface FlowRun {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  ended?: string | null;
  /** @format int32 */
  endResult?: number;
  /** @format int32 */
  currentStep?: number;
  flowRunReplies?: FlowRunReply[] | null;
}

export interface FlowRunReply {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format date-time */
  received?: string;
  /** @format uuid */
  assignedUserId?: string | null;
  /** @format uuid */
  actingUserId?: string | null;
  /** @format date-time */
  replied?: string | null;
  reply?: FlowReplyStatus;
  wasDelegated?: boolean;
  /**
   * @deprecated
   * @format uuid
   */
  userId?: string | null;
}

export interface FlowStateResponse {
  flowState?: FlowState;
  flowType?: FlowTypes;
  flowName?: string | null;
  /** @format int32 */
  minFlowCount?: number;
  /** @format int32 */
  approveCount?: number;
  /** @format int32 */
  rejectCount?: number;
  /** @format date-time */
  flowStartDate?: string | null;
  flowStateProgress?: {
    Selected?: FlowStateUserReply[];
    Processed?: FlowStateUserReply[];
    InProgress?: FlowStateUserReply[];
    Upcoming?: FlowStateUserReply[];
    Approved?: FlowStateUserReply[];
    Declined?: FlowStateUserReply[];
  } | null;
}

export interface FlowStateUserReply {
  /** @format uuid */
  userId?: string | null;
  user?: User;
  /** @format date-time */
  received?: string | null;
  reply?: FlowReplyStatus;
  /** @format uuid */
  replyBy?: string | null;
  /** @format date-time */
  replied?: string | null;
}

export interface FlowTemplate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 550
   */
  description?: string | null;
  flowType?: FlowTypes;
  active?: boolean;
  /**
   * @minLength 0
   * @maxLength 255
   */
  groupName?: string | null;
  visible?: boolean;
  /** @format int32 */
  rejectCount?: number;
  /** @format int32 */
  approveCount?: number;
  /** @format int32 */
  minFlowCount?: number;
  flowTemplateParticipants?: FlowTemplateParticipant[] | null;
}

export interface FlowTemplatePaginationResponseObject {
  data: FlowTemplate[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface FlowTemplateParticipant {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  userId?: string;
  /** @format int32 */
  flowIndex?: number;
  user?: User;
}

export interface ForgotPasswordRequestDTO {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  returnUrl: string;
}

export interface ForgotPasswordResponse {
  /** @format int32 */
  statusCode?: number;
  message?: string | null;
  /** @minLength 1 */
  email: string;
}

export interface GuidIdentityRole {
  /** @format uuid */
  id?: string;
  name?: string | null;
  normalizedName?: string | null;
  concurrencyStamp?: string | null;
}

export interface HistoryEvent {
  /** @format int32 */
  eventId?: number;
  /**
   * @minLength 0
   * @maxLength 450
   */
  username?: string | null;
  /** @format uuid */
  userId?: string;
  /**
   * @minLength 0
   * @maxLength 5000
   */
  message?: string | null;
  /** @format byte */
  attachment?: string | null;
  /** @format date-time */
  created?: string;
}

export interface ImportConfig {
  api_id?: string | null;
}

export interface ImportData {
  channel?: string | null;
  config?: ImportConfig;
  flow_id?: string | null;
}

export interface InboundDocument {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string;
  /** @format uuid */
  companyId?: string | null;
  /** @format uuid */
  organisationId?: string | null;
  /** @format uuid */
  relatedDocumentId?: string | null;
  /** @format uuid */
  itemId?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  subject?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  fromAddress?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  toAddress?: string | null;
  status: InboundStatus;
  receivalType: ReceivalType;
  /** @format date-time */
  processingStarted?: string | null;
  /** @format date-time */
  processingFinished?: string | null;
  documentType: DocumentType;
  /**
   * @minLength 0
   * @maxLength 350
   */
  storagePath?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  fileName?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  fileType?: string | null;
  /** @format int32 */
  fileSize?: number;
  /**
   * @minLength 0
   * @maxLength 1500
   */
  errorMessage?: string | null;
  /** @format date-time */
  created?: string;
  /** @format int32 */
  processingTimeInSeconds?: number;
  ocrProfile?: OcrProfile;
  organisation?: Organisation;
  company?: Company;
}

export interface InboundDocumentPaginationResponseObject {
  data: InboundDocument[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface InboundDocumentStat {
  type?: OcrDocumentType;
  validation?: boolean;
  /** @format int32 */
  processingTimeInSeconds?: number;
  /** @format int32 */
  documentCount?: number;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface InboundEmailAttachment {
  fileName?: string | null;
  contentType?: string | null;
  contentDisposition?: string | null;
  fileSize?: string | null;
  /** @format byte */
  content?: string | null;
  secureStoragePath?: string | null;
}

export interface IntegrationType {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  normalizedName: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  logoUrl?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  shortLogoUrl?: string | null;
  systemType?: IntegrationSystemType;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  authorizationUrl: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  tokenUrl: string;
}

export interface InviteCompanyRequest {
  /** @format uuid */
  companyId: string;
  role: Role;
}

export interface InviteUserRequest {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  language: string;
  companies: InviteCompanyRequest[];
}

export interface Item {
  additionalFields?: ExtendedEntityField[] | null;
  tenantId?: string | null;
  /** @format uuid */
  id: string;
  /** @format int32 */
  docId: number;
  /** @format date-time */
  created?: string | null;
  /**
   * @minLength 0
   * @maxLength 450
   */
  owner?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  creditorName?: string | null;
  creditor?: Creditor;
  /** @format double */
  totalAmount?: number | null;
  /** @format date-time */
  dueDate?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  creditorNo?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  invoiceNo?: string | null;
  deleted?: string | null;
  isCreditNote: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  voucherNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  currencyCode?: string | null;
  flowStatus: FlowStatus;
  /**
   * @minLength 0
   * @maxLength 500
   */
  lockedBy?: string | null;
  /** @format date-time */
  lockedDate?: string | null;
  /** @format date-time */
  invoiceDate?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  fikReference?: string | null;
  /** @format double */
  netAmount?: number | null;
  /** @format double */
  taxAmount?: number | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  reference?: string | null;
  paid: boolean;
  /** @format date-time */
  paymentDate?: string | null;
  /** @format int32 */
  documentType: number;
  /**
   * @minLength 0
   * @maxLength 50
   */
  fikCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  fikCreditorId?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  domesticBankRegistrationNumber?: string | null;
  paymentScheme?: PaymentScheme;
  /**
   * @minLength 0
   * @maxLength 255
   */
  domesticBankAccountNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  internationalSwiftBic?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  internationalIban?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  requisitionNo?: string | null;
  /** @format double */
  discountAmount?: number | null;
  isAwaitingCreditNote: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  debitor?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  debitorNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  warehouseLocation?: string | null;
  /** @format double */
  rounding?: number | null;
  isReserveInvoice: boolean;
  onHold: boolean;
  /** @format date-time */
  exportStarted?: string | null;
  /** @format date-time */
  exportDateTime?: string | null;
  flowRun?: FlowRun;
  owners?: Owner[] | null;
  ownerArchives?: OwnerArchive[] | null;
  productLines?: ProductLine[] | null;
  accountingLines?: AccountingLine[] | null;
  /** @deprecated */
  historyEvents?: HistoryEvent[] | null;
  notes?: Note[] | null;
  reasons?: Reason[] | null;
  exportStatuses?: ExportStatus[] | null;
  validationResults?: ValidationResult[] | null;
  flow?: ItemFlow;
  [key: string]: any;
}

export interface ItemFlow {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  flowType: FlowTypes;
  participants?: ItemFlowParticipant[] | null;
}

export interface ItemFlowCommandResponse {
  existingFlowCancelled?: boolean;
}

export interface ItemFlowParticipant {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  userId?: string;
  /** @format int32 */
  flowIndex?: number;
  user?: User;
}

export interface ItemFlowRequest {
  flowTemplate?: FlowTemplate;
  /** @format uuid */
  flowTemplateId?: string | null;
  save?: boolean;
}

export interface ItemPaginationResponseObject {
  data: Item[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface ItemReminder {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  itemId: string;
  /** @format date-time */
  mailSentAt?: string | null;
  /** @format date-time */
  remindedAt: string;
  notification?: Notification;
}

export interface ItemWidgetResponse {
  item: Item;
  widget: Widget;
}

export interface LoginMfaRequest {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  email: string;
}

export interface LoginRequest {
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
  /**
   * @format password
   * @minLength 1
   */
  password: string;
}

export interface LoginResponse {
  token?: string | null;
  /** @format date-time */
  expires?: string;
  user: AuthUser;
  twoFactorRequired: boolean;
}

export interface Metadata {
  full_text?: string | null;
  header?: Record<string, MetadataField>;
  lines?: MetadataLines;
}

export interface MetadataField {
  final_value?: any;
  /** @format double */
  final_conf?: number;
}

export interface MetadataLines {
  data?: any[] | null;
}

export interface Module {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  key: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string | null;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string | null;
}

export interface MoveInvoiceRequest {
  /** @format uuid */
  reasonChoiceId?: string;
  userComment?: string | null;
}

export interface Note {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  itemId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  userName?: string | null;
  /** @format uuid */
  userId?: string | null;
  /**
   * @minLength 0
   * @maxLength 5000
   */
  message?: string | null;
}

export interface Notification {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  userId: string;
  isRead: boolean;
  /** @format uuid */
  senderUserId?: string | null;
  senderUser?: NotificationUser;
  isSystemNotification: boolean;
  /** @format uuid */
  entityId?: string | null;
  /**
   * @minLength 0
   * @maxLength 100
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 5000
   */
  body: string;
  context: NotificationContext;
  /**
   * @minLength 0
   * @maxLength 150
   */
  url?: string | null;
  /**
   * @minLength 0
   * @maxLength 50
   */
  icon?: string | null;
  bodyParametersDictionary: Record<string, string>;
  titleParametersDictionary: Record<string, string>;
  badges: NotificationBadge[];
  buttonActionType: NotificationActionType;
  /**
   * @minLength 0
   * @maxLength 250
   */
  buttonActionTranslation: string;
}

export interface NotificationBadge {
  /** @minLength 1 */
  text: string;
  /** @minLength 1 */
  icon: string;
  /** @minLength 1 */
  color: string;
  outlined: boolean;
}

export interface NotificationUser {
  /** @format uuid */
  id: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  displayName: string;
  profilePictureUrl?: string | null;
  workStatus?: NotificationUserWorkStatus;
}

export interface NotificationUserWorkStatus {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  state?: UserWorkingState;
}

export interface OAuthClient {
  /**
   * @minLength 0
   * @maxLength 255
   */
  clientId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  clientSecret: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /** @minLength 1 */
  grantTypes: string;
  /** @minLength 1 */
  scopes: string;
  /** @format int32 */
  accessTokenLifetime?: number | null;
  /** @format int32 */
  refreshTokenLifetime?: number | null;
}

export interface OAuthClientRequest {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  scopes: string[];
  redirectUris?: string | null;
}

export interface OcrProfile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  ocrDocumentType?: OcrDocumentType;
  validation?: boolean;
}

export interface OioAttachment {
  filename?: string | null;
  data?: string | null;
}

export interface OioTemplate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  templateData?: string | null;
  /** @format int32 */
  origin?: number;
  default?: boolean;
}

export interface Organisation {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 250
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 550
   */
  description?: string | null;
}

export interface OrganisationSetting {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  key: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  type: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  value?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  category: string;
}

export interface Owner {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  userId?: string | null;
  /** @format date-time */
  created?: string;
}

export interface OwnerArchive {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  userId?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  userLogin?: string | null;
  /** @format date-time */
  created?: string;
}

export interface PaymentTerm {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  paymentTermsNumber: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  type?: string | null;
  /** @format int32 */
  daysOfCredit?: number | null;
  /** @format int32 */
  monthsOfCredit?: number | null;
  endOfMonth?: boolean;
  /** @format int32 */
  fixedDayOfMonth?: number | null;
  useLastDayOfMonth?: boolean;
}

export interface PaymentType {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  paymentTypeNumber: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 200
   */
  category?: string | null;
  isImmediatePayment?: boolean;
  isExternalPaymentProvider?: boolean;
  isInvoicePayment?: boolean;
  /** @format int32 */
  defaultDueDays?: number | null;
  glAccount?: string | null;
}

export interface PdfFileResponse {
  fileName?: string | null;
  /** @format byte */
  fileData?: string | null;
}

export interface Permission {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  key: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  translationKey: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  descriptionTranslationKey: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  category: string;
  read: boolean;
  write: boolean;
  enabled: boolean;
  userEditable: boolean;
  /** @format date-time */
  created?: string;
}

export interface PermissionResponse {
  /** @minLength 1 */
  key: string;
  read: boolean;
  write: boolean;
  enabled: boolean;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProductLine {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  itemId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  itemNo?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 5000
   */
  description?: string | null;
  /** @format double */
  quantity?: number;
  /** @format double */
  unitPrice?: number;
  /** @format double */
  linePrice?: number;
  /**
   * @minLength 0
   * @maxLength 500
   */
  accountingCost?: string | null;
  /** @format date-time */
  created?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  ownerName?: string | null;
  /** @format double */
  discountPercentage?: number;
  /** @format double */
  discountAmount?: number;
  /**
   * @minLength 0
   * @maxLength 500
   */
  unit?: string | null;
  /** @format double */
  baseQuantity?: number;
  /** @format double */
  availableMatchQuantity?: number;
  /** @format uuid */
  additionalExpenseId?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  vatCode?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  projectNo?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  projectArt?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  projectTask?: string | null;
  /** @format uuid */
  relatedProductLineId?: string | null;
  isAggregatedLine?: boolean;
  isSplitLine?: boolean;
}

export interface Project {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  projectNumber: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 3000
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  customerNumber?: string | null;
  active?: boolean;
  /**
   * @minLength 0
   * @maxLength 255
   */
  responsibleEmployeeNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  coResponsibleEmployeeNumber?: string | null;
  responsibleEmployee?: Employee;
  coResponsibleEmployee?: Employee;
}

export interface ProjectPaginationResponseObject {
  data: Project[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface ReAssignUserInFlowRequest {
  /** @format uuid */
  currentUserId?: string;
  /** @format uuid */
  targetUserId?: string;
  actionType: ForwardPolicy;
}

export interface Reason {
  /** @format uuid */
  id: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  itemId?: string;
  /** @format int32 */
  reasonType?: number;
  /** @format uuid */
  userId?: string | null;
  /** @format int32 */
  reasonMessage?: number;
  /**
   * @minLength 0
   * @maxLength 4000
   */
  userReasonMessage?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  userComment?: string | null;
  /** @format date-time */
  created?: string;
  /** @format uuid */
  widgetId?: string | null;
}

export interface ReasonChoice {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 800
   */
  reasonMessage?: string | null;
  reasonType?: ReasonTypes;
}

export interface Recipient {
  email?: string | null;
  name?: string | null;
}

export interface RecipientMapping {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  companyId?: string | null;
  /** @format uuid */
  organisationId?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  recipientMail: string | null;
  documentType?: DocumentType;
  company?: Company;
  organisation?: Organisation;
}

export interface RemindItemRequest {
  tenantId?: string | null;
  /** @format uuid */
  itemId?: string;
  /** @format uuid */
  ownerId?: string;
  returnUrl?: string | null;
}

export interface RemoveUserFromCompanyRequest {
  /** @format uuid */
  companyId?: string;
  /** @format uuid */
  userId?: string;
  /** @format uuid */
  replacementUserId?: string;
}

export interface RemoveUserFromCompanyResult {
  /** @format uuid */
  companyId?: string;
  success?: boolean;
  /** @format int32 */
  flows?: number;
  /** @format int32 */
  documents?: number;
}

export interface ResetPassword {
  /** @minLength 1 */
  email: string;
  token?: string | null;
  password?: string | null;
  confirmPassword?: string | null;
}

export interface ResetPasswordResponse {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  message: string;
  /** @minLength 1 */
  email: string;
}

export interface RestoreInvoiceRequest {
  reasonType?: ReasonTypes;
}

export interface Role {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  translationKey: string;
  descriptionTranslationKey?: string | null;
  /** @format int32 */
  userCount?: number;
  /** @minLength 1 */
  icon: string;
}

export interface RoleContext {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  role: GuidIdentityRole;
  applicationRole?: Role;
}

export interface SendToUserRequest {
  /** @format uuid */
  userId?: string;
  replace?: boolean;
}

export interface Sender {
  raw?: string | null;
  name?: string | null;
  email?: string | null;
}

export interface ServiceEmailRequest {
  /** @format uuid */
  id?: string;
  type?: string | null;
  url?: string | null;
  inboundId?: string | null;
  mailId?: string | null;
  recipient?: Recipient;
  from?: Sender;
  email?: string | null;
  subject?: string | null;
  body?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  /** @format date-time */
  mailCreated?: string;
  attachments?: InboundEmailAttachment[] | null;
}

export interface ServiceOioRequest {
  /** @format uuid */
  id?: string;
  sender?: string | null;
  receiver?: string | null;
  docNumber?: string | null;
  reference?: string | null;
  docType?: string | null;
  message?: string | null;
  filename?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  /** @format date-time */
  oioCreated?: string;
  sentToBatchFlow?: boolean;
  /** @format int32 */
  retries?: number;
  attachments?: OioAttachment[] | null;
}

export interface SetPasswordRequest {
  currentPassword?: string | null;
  /** @minLength 1 */
  password: string;
  /** @minLength 1 */
  confirmPassword: string;
}

export interface SetUserRoleRequest {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  companyId: string;
}

export interface TenantConfiguration {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  key: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  value: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  type: string;
  /** @format int32 */
  sortOrder?: number;
  /**
   * @minLength 0
   * @maxLength 250
   */
  category?: string | null;
}

export interface TranslateColumn {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  columnName: string;
  languageKey?: string | null;
  text?: string | null;
}

export interface Translation {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  keyName: string;
  /**
   * @minLength 0
   * @maxLength 25
   */
  lanKey?: string | null;
  /**
   * @minLength 0
   * @maxLength 8000
   */
  text?: string | null;
  /**
   * @minLength 0
   * @maxLength 250
   */
  category?: string | null;
  /**
   * @minLength 0
   * @maxLength 250
   */
  subCategory?: string | null;
  maxLength?: string | null;
}

export interface TranslationText {
  /** @minLength 1 */
  lanKey: string;
  /** @minLength 1 */
  text: string;
}

export interface User {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  email: string;
  phoneNumber?: string | null;
  /**
   * @minLength 0
   * @maxLength 350
   */
  displayName: string | null;
  mustChangePassword?: boolean;
  isServiceUser?: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   */
  employeeId?: string | null;
  isActive: boolean;
  /**
   * @minLength 0
   * @maxLength 10
   */
  language: string;
  profilePictureUrl?: string | null;
  companies: UserCompany[];
  userInvitations?: UserInvitationBase[] | null;
  approvalLimits: ApprovalLimit[];
  workStatus?: WorkingStatus;
}

export interface UserCompany {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  delegate?: Delegate;
  company: Company;
}

export interface UserDelegateUpdate {
  serialNumber?: string | null;
  delegate?: Delegate;
}

export interface UserInvitation {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  token: string;
  /** @format date-time */
  expirationDate: string;
  step: InvitationStep;
  user?: User;
}

export interface UserInvitationBase {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  token: string;
  /** @format date-time */
  expirationDate: string;
  step: InvitationStep;
}

export interface UserInvitationRequest {
  /** @minLength 1 */
  displayName: string;
  phoneNumber?: string | null;
  /** @minLength 1 */
  language: string;
}

export interface UserInvitationStep {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @minLength 1 */
  token: string;
  step: InvitationStep;
}

export interface UserPaginationResponseObject {
  data: User[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface UserReference {
  /** @format uuid */
  id?: string;
  displayName?: string | null;
  email?: string | null;
  profilePictureUrl?: string | null;
}

export interface UserRemoveAffectResponse {
  /** @format int32 */
  flowsAffected?: number;
  /** @format int32 */
  documentsAffected?: number;
  /** @format int32 */
  delegationsAffected?: number;
}

export interface UserSetting {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  keyName: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  keyValue?: string | null;
}

export interface UserWorkStatusRequest {
  /** @format uuid */
  userId: string;
  isWorking: boolean;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate?: string | null;
  userCompanies?: UserDelegateUpdate[] | null;
}

export interface ValidateEmailRequest {
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  email: string;
}

export interface ValidateResetTokenRequest {
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  email: string;
}

export interface ValidationCondition {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format uuid */
  dependentConditionId?: string | null;
  action?: ValidationAction;
  type?: ValidationConditionType;
  enabled?: boolean;
  optional?: boolean;
  /** @format int32 */
  sortOrder?: number;
  /**
   * @minLength 0
   * @maxLength 500
   */
  translationKey?: string | null;
  documentType?: DocumentType;
  options?: ValidationConditionOption[] | null;
}

export interface ValidationConditionOption {
  type?: ValidationConditionOptionType;
  fields?: string[] | null;
  /** @format int32 */
  maximumAgeDays?: number | null;
}

export interface ValidationConditionSortUpdate {
  action?: ValidationAction;
  /** @format int32 */
  documentType?: number;
  validationConditionIds?: string[] | null;
}

export interface ValidationFieldOption {
  /**
   * @minLength 0
   * @maxLength 255
   */
  scope: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  prop: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  jsonName: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  type: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  displayName?: string | null;
  isCustomField?: boolean;
}

export interface ValidationResult {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  success: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  error: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  errorType: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  fieldPath: string;
  optional: boolean;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  errorParameters?: string | null;
  errorParametersDictionary?: Record<string, string>;
}

export interface VatGroup {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 500
   */
  importKey: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  vatCode: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  name?: string | null;
  /**
   * @minLength 0
   * @maxLength 25
   */
  countryCode?: string | null;
  scope?: VatScope;
  /** @format double */
  vatRate?: number | null;
  category?: VatCategory;
  direction?: VatDirection;
  active?: boolean;
  isReverseCharge?: boolean;
}

export interface VatGroupPaginationResponseObject {
  data: VatGroup[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface Widget {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  normalizedName: string;
  type: WidgetType;
  /**
   * @minLength 0
   * @maxLength 150
   */
  description?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   */
  icon: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  color: string;
  enabled: boolean;
  /** @format int32 */
  itemCount?: number | null;
  keyboardShortcuts?: Record<string, string>;
  columns?: WidgetColumn[] | null;
  buttons?: Record<string, string>;
  multiSelectorButtons?: Record<string, string>;
  listButtons?: WidgetListButton[] | null;
  itemAttributes?: string[] | null;
  itemButtons?: WidgetItemButton[] | null;
}

export interface WidgetColumn {
  /** @format uuid */
  id: string;
  prop: WidgetColumnProp;
  /** @minLength 1 */
  name: string;
  reversed?: boolean;
  sortable?: boolean;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  minWidth?: number | null;
  /** @format int32 */
  maxWidth?: number | null;
  /** @format int32 */
  sortOrder?: number;
  /** @format int32 */
  defaultSortOrder?: number;
  enabled?: boolean;
  visible?: boolean;
  defaultVisible?: boolean;
  draggable?: boolean;
}

export interface WidgetItemButton {
  /**
   * @minLength 1
   * @maxLength 250
   */
  button: string;
  subButtons?: WidgetItemButton[] | null;
}

export interface WidgetListButton {
  /**
   * @minLength 1
   * @maxLength 250
   */
  button: string;
  subButtons?: WidgetListButton[] | null;
}

export interface WorkingStatus {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string | null;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate?: string | null;
  state?: UserWorkingState;
}
